/* eslint-disable promise/catch-or-return */
import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import * as PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import get from 'lodash/get';

import Popup from '../../../common/Popup';
import AudioSettings from './AudioSettings';
import VideoSettings from './VideoSettings';
import Loader from '../../../common/Loader';
import TestConnection from './TestConnection';
import VideoView from './VideoSettings/VideoView';
import ErrorBlock from '../../../common/ErrorBlock';
import { OTContext } from '../../../../redux/opentok/context';
import { VIRTUAL_VISIT_INVITE_TYPE } from '../../../../constants';
import { useForceUpdate } from '../../../../redux/opentok/hooks/useForceUpdate';
import { subscribeToForceUpdate } from '../../../../redux/opentok/helpers/notifications';
import { selectInvitationTypeFromConfig } from '../../../../redux/healthboard/selectors';
import styles from './styles.styl';

function MediaSettings({ formatMessage }) {
  const ctx = useContext(OTContext);
  const forceUpdate = useForceUpdate();
  const { state, PUBLISHER_KEY, otPublisher } = ctx;
  const { [PUBLISHER_KEY]: publisher } = state.connections;
  const inviteType = useSelector(selectInvitationTypeFromConfig);

  const hideTestButton = [
    VIRTUAL_VISIT_INVITE_TYPE.GUEST,
    VIRTUAL_VISIT_INVITE_TYPE.PATIENT,
    VIRTUAL_VISIT_INVITE_TYPE.IN_OFFICE,
    VIRTUAL_VISIT_INVITE_TYPE.CONNECTION_ROOM,
  ].includes(inviteType);

  const videoDevices = get(
    otPublisher,
    'initialMediaDevices.videoSourceList',
    [],
  );
  const audioDevices = get(
    otPublisher,
    'initialMediaDevices.audioSourceList',
    [],
  );

  useEffect(() => subscribeToForceUpdate(forceUpdate), []);
  useEffect(() => {
    if (otPublisher) otPublisher.updateDeviceList().then(forceUpdate);
  }, []);

  const [error] = useState(null);

  if (!publisher) return <Loader />;

  return (
    <div className={styles.modal}>
      <VideoView publisher={publisher} />
      {!hideTestButton && <TestConnection formatMessage={formatMessage} />}
      {error && (
        <ErrorBlock className="mb3" errors={formatMessage({ id: error })} />
      )}
      <div>
        <VideoSettings
          publisher={publisher}
          devices={videoDevices}
          otPublisher={otPublisher}
          formatMessage={formatMessage}
        />
        <AudioSettings
          publisher={publisher}
          devices={audioDevices}
          otPublisher={otPublisher}
          formatMessage={formatMessage}
        />
      </div>
      <div className={styles.btns} id="media-settings-button" />
    </div>
  );
}

MediaSettings.propTypes = {
  formatMessage: PropTypes.func,
};

function MediaSettingsModal({ intl: { formatMessage }, opened, close }) {
  const handleClose = () => close();

  return (
    <Popup
      className={styles.popup}
      opened={opened}
      onClose={handleClose}
      title={formatMessage({ id: 'common.settings' })}
      width="auto"
      autoHeight
      white
      strictClose
    >
      <MediaSettings formatMessage={formatMessage} />
    </Popup>
  );
}

MediaSettingsModal.propTypes = {
  intl: PropTypes.object,
  opened: PropTypes.bool,
  close: PropTypes.func,
};

export default injectIntl(MediaSettingsModal);



// WEBPACK FOOTER //
// ./src/components/VirtualVideoRoom/Components/MediaSettings/index.jsx